import { createFileRoute } from "@tanstack/react-router";

import { DatasourcesPage } from "~/pages/datasources/datasources.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/datasources/",
)({
  component: DatasourcesPage,
});
